import React from 'react';
import { ArrowRightIcon, TagIcon } from 'lucide-react';
interface CTAButtonRlt1Props {
  productName?: string;
  regularPrice?: string;
  salePrice?: string;
  discount?: string;
  url?: string;
  trackingName?: string;
}
const CTAButtonRlt1: React.FC<CTAButtonRlt1Props> = ({
  productName = 'Glokore Targeted Red Light Therapy Belt',
  regularPrice = '$219.98',
  salePrice = '$109.99',
  discount = 'Production Cost Pricing',
  url = 'https://glokore.com/wraps/checkout4wl/?affId=nva&uid=3410&c2=698&c1=719',
  trackingName = 'Glokore Red Light Therapy Belt'
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Facebook Pixel tracking (fire-and-forget)
    setTimeout(() => {
      try {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'Advertorial_ClickToOffer', {
            content_name: trackingName,
            content_category: 'Health',
            value: parseFloat(salePrice.replace(/[^\d.]/g, ''))
          });
        }
      } catch (error) {
        console.error('Facebook Pixel tracking error:', error);
      }
    }, 0);
    // Google Tag Manager tracking (fire-and-forget)
    setTimeout(() => {
      try {
        if (typeof window !== 'undefined' && (window as any).gtag) {
          ;
          (window as any).gtag('event', 'conversion', {
            send_to: 'AW-17548177287/xQtBCOLL2LsbEIffz69B',
            value: parseFloat(salePrice.replace(/[^\d.]/g, ''))
          });
        }
      } catch (error) {
        console.error('Google Tag Manager tracking error:', error);
      }
    }, 0);
  };
  return <div className="w-full max-w-md mx-auto border border-gray-300 rounded-lg p-4 bg-white" data-id="element-16931" data-mp="ms1thbzde9hh">
      <div className="flex items-center gap-1.5 mb-2" data-id="element-16932" data-mp="hua1khyq6nda">
        <TagIcon className="h-3.5 w-3.5 text-gray-600" data-id="element-16933" data-mp="wqhk7duhjgqg" />
        <span className="text-xs font-medium text-gray-600 uppercase tracking-wide" data-id="element-16934" data-mp="wowq1pc31zt4">
          READER ACCESS
        </span>
      </div>

      <h3 className="text-base font-serif font-medium text-gray-900 mb-1.5" data-id="element-16935" data-mp="yve53lcg6ka1">
        {productName}
      </h3>

      <div className="flex items-center gap-1.5 mb-3" data-id="element-16936" data-mp="13tfqicxcivoo">
        <span className="text-sm text-gray-400 line-through" data-id="element-16937" data-mp="13s4p2jrdi00q">
          {regularPrice}
        </span>
        <span className="text-base font-medium text-green-600" data-id="element-16938" data-mp="18rh8svmy6qz3">
          {salePrice}
        </span>
        <span className="bg-yellow-100 text-yellow-800 text-xs font-semibold px-2.5 py-1 rounded" data-id="element-16939" data-mp="1dltvdejq0if2">
          {discount}
        </span>
      </div>

      <a href={url} onClick={handleClick} target="_blank" rel="noopener noreferrer" className="block w-full bg-gray-900 hover:bg-gray-800 text-white font-medium text-base py-3 px-6 rounded transition-colors duration-200 text-center" data-id="element-16940" data-mp="1mjnoyhq3oxyj">
        <span className="flex items-center justify-center gap-2" data-id="element-16941" data-mp="1wi3ewhde616g">
          Access Offer
          <ArrowRightIcon className="h-4 w-4" data-id="element-16942" data-mp="3tcpudsho014f" />
        </span>
      </a>
    </div>;
};
export default CTAButtonRlt1;